import { createContext, useContext, useCallback, useEffect, useState } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { useSettings } from '../contexts/SettingsContext';

const RecaptchaContext = createContext(null);

// Bridge component that extracts executeRecaptcha from the library provider
// and passes it down through our own context
export function RecaptchaBridge({ children }) {
  const { executeRecaptcha } = useGoogleReCaptcha();
  const [ready, setReady] = useState(false);

  useEffect(() => {
    if (executeRecaptcha) {
      setReady(true);
    }
  }, [executeRecaptcha]);

  return (
    <RecaptchaContext.Provider value={ready ? executeRecaptcha : null}>
      {children}
    </RecaptchaContext.Provider>
  );
}

export function useRecaptcha() {
  const { settings } = useSettings();
  const executeRecaptcha = useContext(RecaptchaContext);
  const isActive = settings.recaptcha_enabled && settings.recaptcha_site_key;

  const getRecaptchaToken = useCallback(async (action) => {
    if (!isActive || !executeRecaptcha) {
      return null;
    }
    try {
      return await executeRecaptcha(action);
    } catch (err) {
      console.error('Failed to get reCAPTCHA token:', err);
      return null;
    }
  }, [isActive, executeRecaptcha]);

  return { getRecaptchaToken, isActive };
}

export function RecaptchaNotice() {
  const { settings } = useSettings();
  const isActive = settings.recaptcha_enabled && settings.recaptcha_site_key;

  if (!isActive) return null;

  return (
    <p className="text-xs text-gray-400 mt-2">
      This site is protected by reCAPTCHA and the Google{' '}
      <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-500">Privacy Policy</a> and{' '}
      <a href="https://policies.google.com/terms" target="_blank" rel="noopener noreferrer" className="underline hover:text-gray-500">Terms of Service</a> apply.
    </p>
  );
}
